import React, { useContext } from "react";
import Switch from "@mui/material/Switch";
import { FormControlLabel, FormGroup } from "@mui/material";
import { OverviewContext } from "src/components/providers/overview-provider";

const BreakdownSwitch = () => {
    const { expandedView, setExpandedView } = useContext(OverviewContext);
    const handleChange = (e) => {
        setExpandedView(e.target.checked);
    };

    return (
        <FormGroup>
            <FormControlLabel
                control={
                    <Switch
                        checked={expandedView}
                        onChange={handleChange}
                        size="small"
                        inputProps={{ "aria-label": "controlled" }}
                    />
                }
                label={<p style={{ fontSize: "12px" }}>View breakdown</p>}
            />
        </FormGroup>
    );
};

export default BreakdownSwitch;
